// ** React Imports
import { useState } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { styled } from '@mui/material/styles'
import MuiTab from '@mui/material/Tab'

// ** Icons Imports
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import LockIcon from '@mui/icons-material/Lock';
import InfoIcon from '@mui/icons-material/Info';

// ** Demo Tabs Imports


// ** Third Party Styles Imports
import 'react-datepicker/dist/react-datepicker.css'
import TabInfo from '../../views/trainer/accountsettings/TabInfo'
import StudentPersonalInfo from './StudentPersonalInfo'
import StudentCourseDetails from './StudentCourseDetails'
import StudentPaymentDetails from './StudentPaymentDetails'
import StudentTestDetails from './StudentTestDetails'

const Tab = styled(MuiTab)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    minWidth: 100
  },
  [theme.breakpoints.down('sm')]: {
    minWidth: 67
  }
}))

const TabName = styled('span')(({ theme }) => ({
  lineHeight: 1.71,
  fontSize: '0.875rem',
  marginLeft: theme.spacing(2.4),
  [theme.breakpoints.down('md')]: {
    display: 'none'
  }
}))

const StudentProfileTab = ({studentDetails}) => {
  // ** State
  const [value, setValue] = useState('personal_info')

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Card>
      <TabContext value={value}>
        <TabList
          onChange={handleChange}
          aria-label='account-settings tabs'
          sx={{ borderBottom: theme => `1px solid ${theme.palette.divider}` }}
        >
          <Tab
            value='personal_info'
            label={
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <AccountBoxIcon />
                <TabName>Personal Info</TabName>
              </Box>
            }
          />
          <Tab
            value='course_details'
            label={
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <LockIcon />
                <TabName>Course Details</TabName>
              </Box>
            }
          />
          <Tab
            value='payment_details'
            label={
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <InfoIcon />
                <TabName>Payment Details</TabName>
              </Box>
            }
          />
           <Tab
            value='test_details'
            label={
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <InfoIcon />
                <TabName>Test Details</TabName>
              </Box>
            }
          />
        </TabList>

        <TabPanel sx={{ p: 0 }} value='personal_info'>
          <StudentPersonalInfo studentDetails={studentDetails}/>
        </TabPanel>
        <TabPanel sx={{ p: 0 }} value='course_details'>
          <StudentCourseDetails />
        </TabPanel>
        <TabPanel sx={{ p: 0 }} value='payment_details'>
          <StudentPaymentDetails />
        </TabPanel>
        <TabPanel sx={{ p: 0 }} value='test_details'>
          <StudentTestDetails />
        </TabPanel>
      </TabContext>
    </Card>
  )
}

export default StudentProfileTab